const API_BASE = 'https://homee-api.hlancaric.workers.dev';

/**
 * SUPPORT AI — 24/7 autonomous first-line support.
 * Calls the homee-api Worker, which holds the OpenAI key server-side and
 * has service-role access to job context. Falls back to rule-based replies
 * server-side when no OPENAI_API_KEY is configured.
 */
export class SupportAI {
  public static async handleSupportQuery(jobId: string, message: string): Promise<string> {
    try {
      const res = await fetch(`${API_BASE}/support`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jobId, message }),
      });
      const data = (await res.json()) as { reply?: string; error?: string };
      return data.reply ?? 'Omlouváme se, podpora je momentálně nedostupná. Zkuste to prosím za chvíli.';
    } catch {
      return 'Omlouváme se, podpora je momentálně nedostupná. Zkuste to prosím za chvíli.';
    }
  }
}
